export default __webpack_public_path__ + "static/media/undead_block_logo.3e4e5f8f.png";